<template>
  <v-container class="pa-0">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          style="width: auto; height: auto"
          icon
          v-bind="attrs"
          v-on="on"
          @click="
            openLink(
              'https://abriron.com/%d8%a2%d9%85%d9%88%d8%b2%d8%b4-%d9%86%d8%b1%d9%85-%d8%a7%d9%81%d8%b2%d8%a7%d8%b1-%d8%ad%d8%b3%d8%a7%d8%a8%d8%af%d8%a7%d8%b1%db%8c-%d8%a2%d9%86%d9%84%d8%a7%db%8c%d9%86/'
            )
          "
        >
          <my-icon
            :name="'question-icon'"
            :fill="$vuetify.theme.isDark ? '#fff' : '#000'"
            :width="18"
            :height="18"
            :cursor-pointer="true"
          />
        </v-btn>
      </template>
      <span>{{ $t("learn") }}</span>
    </v-tooltip>
  </v-container>
</template>

<script>
import MyIcon from "@/views/dashboard/components/general/icon/MyIcon.vue";

export default {
  methods: {
    openLink(link) {
      window.open(link, "_blank");
    },
  },
  components: {
    MyIcon,
  },
};
</script>

<style scoped></style>
